import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function NewRelicRouteTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const nr = typeof window !== 'undefined' ? window.newrelic : undefined;
    if (!nr) return;

    const routeName = `${pathname || '/'}${search || ''}`;

    try {
      if (typeof nr.setCurrentRouteName === 'function') {
        nr.setCurrentRouteName(routeName);
      }
    } catch (error) {
      // Intentionally swallow errors from monitoring SDK calls.
    }

    try {
      if (typeof nr.addPageAction === 'function') {
        nr.addPageAction('route_change', {
          routeName,
          pathname: pathname || '/',
          search: search || '',
        });
      }
    } catch (error) {
      // Intentionally swallow errors from monitoring SDK calls.
    }
  }, [pathname, search]);

  return null;
}
